const $ = require('jquery')
const View = require('public_framework/view')

const TOGGLE_CLASS = 'is-toggled'

module.exports = class Dropdown extends View {
  get els () {
    return {
      $dropdown: '@dropdown'
    }
  }

  get events () {
    return {
      'click @toggle': 'toggle'
    }
  }

  unload () {
    $('body').off('click.dropdown')
  }

  toggle (e) {
    e.stopPropagation()
    this._visible = !this._visible
    this.$dropdown().toggleClass(TOGGLE_CLASS, this._visible)

    if (this._visible) {
      $('body').on('click.dropdown', () => this.hide())
    }
  }

  hide () {
    this._visible = false
    this.$dropdown().removeClass(TOGGLE_CLASS)
    $('body').off('click.dropdown')
  }
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/ui/dropdown/views/dropdown.js